import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthApiV2Module } from './auth/auth-api-v2.module';
import { CentralEventsModule } from './central-events/central-events.module';
import { DamageEventsModule } from './damage-events/damage-events.module';
import { TaskReserveModule } from './task-reserve/task-reserve.module';
import { TasksModule } from './tasks/tasks.module';
import { ProfileModule } from './profile/profile.module';
import { GTNetModule } from './gtnet/gtnet.module';
import { PartnersModule } from './partners/partners.module';
import { TaskProtectedValueModule } from './task-protected-value/task-protected-value.module';
import { TaskReportsModule } from './task-reports/task-reports.module';
import { PartnerUsersModule } from './partner-users/partner-users.module';
import { PartnerNotificationEmailsModule } from './partner-notification-emails/partner-notification-emails.module';
import { SentEmailLogsModule } from './sent-email-logs/sent-email-logs.module';
import { TaskFileGroupTypesModule } from './task-file-group-types/task-file-group-types.module';
import { CurrenciesModule } from './currencies/currencies.module';
import { TaskFilesModule } from './task-files/task-files.module';
import { TaskFileGroupsModule } from './task-file-groups/task-file-groups.module';
import { ProtectedValuesModule } from './protected-values/protected-values.module';
import { VatRatesModule } from './vat-rates/vat-rates.module';
import { PartialDamageReportsModule } from './partial-damage-reports/partial-damage-reports.module';
import { CountriesModule } from './countries/countries.module';
import { RepairInvoiceTypesModule } from './repair-invoice-types/repair-invoice-types.module';
import { UniqaSyncJobsModule } from './uniqa-sync-jobs/uniqa-sync-jobs.module';

@NgModule({
  imports: [CommonModule],
  exports: [
    TaskFileGroupsModule,
    TaskFilesModule,
    ProfileModule,
    CountriesModule,
    RepairInvoiceTypesModule,
    CurrenciesModule,
    TaskFileGroupTypesModule,
    SentEmailLogsModule,
    AuthApiV2Module,
    PartnerUsersModule,
    PartnerNotificationEmailsModule,
    PartnersModule,
    CentralEventsModule,
    GTNetModule,
    DamageEventsModule,
    TaskReserveModule,
    TaskProtectedValueModule,
    TaskReportsModule,
    PartialDamageReportsModule,
    TasksModule,
    ProtectedValuesModule,
    VatRatesModule,
    UniqaSyncJobsModule,
  ],
})
export class RestModule {}
